import { PrincipalPaymentParams } from 'app/models/principal-payments-params'
import { PrincipalPaymentState } from './reducer'

export const getPrincipalPayments = (state: {
  principalPayments: { principalPayments: PrincipalPaymentParams[] }
}) => state.principalPayments.principalPayments

export const getPrincipalPaymentsLoader = (state: { principalPayments: PrincipalPaymentState }) => 
  state.principalPayments.isLoading 
